import React from 'react'
import styled from '@emotion/styled'

import { breakpoints } from '../../constants'
import { grayLight40 } from '../../constants/principles'

export default () => <StyledGreyDotDiv />

const StyledGreyDotDiv = styled.div`
  width: 12px;
  height: 12px;
  margin: 0px 4px;
  @media (min-width: ${breakpoints.mid}px) {
    width: 16px;
    height: 16px;
    margin: 0px 8px;
  }
  border-radius: 50%;
  cursor: not-allowed;
  background-color: ${grayLight40};
`
